
/**
 * Member Benefits Tracking Script
 * Tracks when users visit member benefits page and sets flag for registration flow
 */

// (function () {
//   'use strict';

//   function setMemberBenefitsFlag() {
//     sessionStorage.setItem('fromMemberBenefits', 'true');
//     sessionStorage.setItem('addSubscriptionAfterRegister', 'true');
//   }

//   function initTracking() {
//     // Check if user is on member benefits page
//     const pathname = window.location.pathname;
//     const isMemberBenefitsPage = pathname.includes('/pages/member-benefits') ||
//       pathname === '/pages/member-benefits' ||
//       pathname.includes('/pages/member-benefits/');

//     if (isMemberBenefitsPage) {
//       // Set flag when on member benefits page
//       // We'll clear it if they click login, and only use it for registration
//       setMemberBenefitsFlag();

//       // Listen for clicks on login links/buttons to clear the flag
//       document.addEventListener('click', function (e) {
//         let target = e.target;

//         // Check if clicked element or its parent is a link
//         while (target && target !== document.body) {
//           if (target.tagName === 'A' || target.closest('a')) {
//             const link = target.tagName === 'A' ? target : target.closest('a');
//             const href = link.href || link.getAttribute('href') || '';

//             // Check if it's a login link - if so, clear the flag
//             const isLoginLink = href.includes('/account/login') ||
//               (href.includes('/account') && href.includes('login')) ||
//               link.textContent.toLowerCase().includes('sign in') ||
//               link.textContent.toLowerCase().includes('log in');

//             if (isLoginLink) {
//               // Clear flag if clicking login - we don't want to add product on sign-in
//               sessionStorage.removeItem('addSubscriptionAfterRegister');
//               sessionStorage.removeItem('fromMemberBenefits');
//               break;
//             }
//           }
//           target = target.parentElement;
//         }
//       }, true); // Use capture phase to catch events early
//     }

//     // Check if user came from member benefits page when on registration page
//     const isRegistrationPage = pathname.includes('/account/register');

//     if (isRegistrationPage) {
//       // Check URL parameters (in case of redirect with params)
//       const urlParams = new URLSearchParams(window.location.search);
//       const fromBenefits = urlParams.get('from') === 'member-benefits';

//       if (fromBenefits) {
//         setMemberBenefitsFlag();
//       }

//       // Also check document.referrer
//       const referrer = document.referrer || '';
//       if (referrer.includes('/pages/member-benefits')) {
//         setMemberBenefitsFlag();
//       }
//     }

//     // Clear flag if user directly navigates to registration (not from member benefits)
//     if (isRegistrationPage) {
//       const fromBenefits = sessionStorage.getItem('fromMemberBenefits');
//       const referrer = document.referrer || '';
//       const urlParams = new URLSearchParams(window.location.search);
//       const hasReferrerParam = urlParams.get('from') === 'member-benefits';

//       // Only clear if there's no indication they came from member benefits
//       if (!fromBenefits && !referrer.includes('/pages/member-benefits') && !hasReferrerParam) {
//         // User came directly to registration - clear any existing flags
//         sessionStorage.removeItem('addSubscriptionAfterRegister');
//       }
//     }
//   }

//   // Run on page load
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initTracking);
//   } else {
//     initTracking();
//   }

//   // Also run after a short delay to catch dynamically loaded content
//   setTimeout(initTracking, 1000);
// })();




(function () {
  'use strict';

  function setMemberBenefitsFlag() {
    sessionStorage.setItem('fromMemberBenefits', 'true');
    sessionStorage.setItem('addSubscriptionAfterRegister', 'true');
  }

  function initTracking() {
    // Check if user is on member benefits page
    const pathname = window.location.pathname;
    const isMemberBenefitsPage = pathname.includes('/pages/member-benefits') ||
      pathname === '/pages/member-benefits' ||
      pathname.includes('/pages/member-benefits/');

    if (isMemberBenefitsPage) {
      // Set flag when on member benefits page
      // This flag will be checked when user navigates to /account/register or /account/login
      setMemberBenefitsFlag();
    }

    // Check if user came from member benefits page when on registration page
    const isRegistrationPage = pathname.includes('/account/register');
    const isLoginPage = pathname.includes('/account/login');

    if (isRegistrationPage) {
      // Check if user came from member benefits page
      const fromBenefits = sessionStorage.getItem('fromMemberBenefits') === 'true';
      const referrer = document.referrer || '';
      const cameFromMemberBenefits = referrer.includes('/pages/member-benefits');
      
      // Check URL parameters (in case of redirect with params)
      const urlParams = new URLSearchParams(window.location.search);
      const fromParam = urlParams.get('from') === 'member-benefits';

      if (fromBenefits || cameFromMemberBenefits || fromParam) {
        // User came from member benefits - ensure flags are set
        setMemberBenefitsFlag();
      } else {
        // User came directly to registration (not from member benefits) - clear flags
        sessionStorage.removeItem('addSubscriptionAfterRegister');
        sessionStorage.removeItem('fromMemberBenefits');
      }
    }

    if (isLoginPage) {
      // Check if user came from member benefits page
      const fromBenefits = sessionStorage.getItem('fromMemberBenefits') === 'true';
      const referrer = document.referrer || '';
      const cameFromMemberBenefits = referrer.includes('/pages/member-benefits');

      if (fromBenefits || cameFromMemberBenefits) {
        // User came from member benefits but is logging in - clear flags (login doesn't add subscription)
        sessionStorage.removeItem('addSubscriptionAfterRegister');
        sessionStorage.removeItem('fromMemberBenefits');
      }
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }

  // Also run after a short delay to catch dynamically loaded content
  setTimeout(initTracking, 1000);
})();
